import { AnnotationTemplate, AnnotationTemplateWithoutContents } from '@paragon/contract-library';

import { SealingService } from '../connections';

export async function fetchAllForUser(): Promise<AnnotationTemplate[]> {
  const loadedTemplates = await SealingService.get('annotationtemplates/getAnnotationTemplatesByUser');

  if (!Array.isArray(loadedTemplates)) {
    throw new Error(`Loaded annotation templates are invalid: ${JSON.stringify(loadedTemplates)}`);
  }

  if (loadedTemplates.length === 0) {
    throw new Error('No annotation templates found');
  }

  return loadedTemplates;
}

export async function fetchAllForUserWithoutContents() {
  return await SealingService.get<AnnotationTemplateWithoutContents[]>(
    'annotationtemplates/getAnnotationTemplatesByUserWithoutContents',
  );
}

interface StampJobRequest {
  readonly restrictStampedPages: boolean;
  readonly pagesToStamp: readonly number[];
  readonly shouldCreateCoverPage: boolean;
  readonly shouldCreateBackPage: boolean;
  readonly portraitTemplate: string;
  readonly landscapeTemplate: string;
}
export async function stampDrawingsAndCreateCoverAndBackPages(
  jobId: number,
  options: Exclude<StampJobRequest, 'jobId'>,
): Promise<void> {
  const data = { ...options, jobId };
  return SealingService.post('annotationTemplates/stampDrawingsAndCreateCoverAndBackPages', { data });
}

export function applyAnnotationTemplateToPage(
  pdfPageId: number,
  annotationTemplateId: number,
  translate = true,
): Promise<void> {
  return SealingService.post('annotationTemplates/applyAnnotationTemplateToPage', {
    data: {
      pdfPageId,
      annotationTemplateId,
      translate,
    },
  });
}

export function applyAnnotationTemplateToAllPagesInPdf(
  jobId: number,
  pdfId: number,
  annotationTemplateId: number,
): Promise<void> {
  return SealingService.post('annotationTemplates/applyAnnotationTemplateToAllPagesInPdf', {
    data: {
      jobId,
      pdfId,
      annotationTemplateId,
    },
  });
}

export function applyAnnotationTemplateToFirstPageOfEveryComponentPdf(
  jobId: number,
  annotationTemplateId: number,
): Promise<void> {
  return SealingService.post('annotationTemplates/applyAnnotationTemplateToAllFirstPagesInAllComponentPdfs', {
    data: {
      jobId,
      annotationTemplateId,
    },
  });
}

export function insert(annotationTemplate: AnnotationTemplate): Promise<AnnotationTemplate> {
  return SealingService.post('annotationTemplates', {
    data: { annotationTemplate, annotations: annotationTemplate.contentsAsAnnotations },
  });
}

export function update(annotationTemplate: AnnotationTemplate): Promise<AnnotationTemplate> {
  return SealingService.put(`annotationTemplates/${annotationTemplate.id}`, {
    data: { annotationTemplate, annotations: annotationTemplate.contentsAsAnnotations },
  });
}

export function remove(annotationTemplateId: number): Promise<AnnotationTemplate> {
  return SealingService.delete(`annotationTemplates/${annotationTemplateId}`);
}
